import React from 'react';
import type { FC } from 'react';
import GeneralModal from './GeneralModal/GeneralModal.lazy';
import type { RootState } from '../../state/store';
import { ModalIcons } from './ModalIcon/ModalIcon';
import { useSelector } from 'react-redux';

export const ConfirmModal: string = 'ConfirmSendModal';

/**
 * Confirm send Modal component
 * Used in compose when sending a message & prompting to confirm
 * Calls generalModal to display data
 */
const ConfirmSend: FC = () => {
  const modalsState = useSelector((state: RootState) => state.modals.custom[ConfirmModal]);
  const handleConfirm = async (event: React.SyntheticEvent): Promise<void> => {
    event.stopPropagation();
    return await new Promise((resolve) => {
      if (modalsState.callback) {
        modalsState.callback();
      }
      resolve();
    });
  }

  const handleCancel = async (): Promise<void> => {
    return await new Promise((resolve) => {
      if (modalsState.cancel) {
        modalsState.cancel();
      }
      resolve();
    });
  }
  return (
    <>
      <GeneralModal
        modalKey={ConfirmModal}
        isVisible={modalsState.isVisible}
        title={modalsState.title}
        content={modalsState.content}
        contentVariable={modalsState.contentVariable}
        heading={modalsState.heading}
        width={538}
        buttons={modalsState.buttons}
        confirmButton={modalsState.confirmButton}
        handleConfirm={handleConfirm}
        handleCancel={handleCancel}
        iconType={ModalIcons.Warning}
      />
    </>
  )
}

export default ConfirmSend;
